import React from 'react';
import { Form, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { ReactComponent as PasswordHide } from '@/views/account/assets/icons/password-hidden.svg';
import { ReactComponent as PasswordShow } from '@/views/account/assets/icons/password-show.svg';
import rules from '@/views/account/constants/rules';
import Validator from '@/views/account/utils/formValidator';

import '@/views/account/assets/forgotAndResetPassWordModal.scss';

const ResetPasswordModalRender = ({
  form,
  email,
  submitting,
  handleSubmitResetPassword,
}) => {
  const { t } = useTranslation(['loginAndSignUp', 'common']);

  /**
   * 自定义密码显示和隐藏icon
   * @param {*} visible
   */
  const passWordIconRender = (visible) =>
    visible ? <PasswordShow /> : <PasswordHide />;
  console.log(email);
  return (
    <div className='forget-and-reset-cont p-md-4 p-0'>
      <h4 className='fw-bold mb-4'>{t('resetPasswordTitle')}</h4>
      <Form
        layout='vertical'
        ref={form}
        name='forgot-password'
        className='w-100'
        onFinish={handleSubmitResetPassword}
        initialValues={{
          email: email,
        }}
        validateTrigger='onBlur'
      >
        <Form.Item name='email' label={t('common:email')}>
          <Input placeholder={t('common:email')} readOnly />
        </Form.Item>
        <Form.Item
          name='newPassword'
          label={t('resetPasswordLabel')}
          rules={[
            {
              required: true,
              validator: Validator.passwordValidator,
            },
          ]}
        >
          <Input.Password
            placeholder={t('resetPasswordPlaceholder')}
            iconRender={passWordIconRender}
            autoComplete='new-password'
            allowClear
          />
        </Form.Item>
        <Form.Item className='mb-0'>
          <Button
            className='fs-6 fw-bolder submit-btn py-2'
            type='primary'
            size='large'
            htmlType='submit'
            loading={submitting}
            style={{ minWidth: '50%' }}
          >
            {t('common:confirm')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ResetPasswordModalRender;
